import { FC } from 'react'
import styled from 'styled-components'
import { Button as IconButton, IconButtonProps } from '../IconButton'

const Button = styled(IconButton)`
  border-radius: 999px;
`

const RoundedButton: FC<IconButtonProps> = props => {
  const { type, size, children, ...rest } = props
  return (
    <Button type='button' variant={type} size={size} {...rest}>
      {children}
    </Button>
  )
}

export default RoundedButton
